import { render, staticRenderFns } from "./OrdersDraft.vue?vue&type=template&id=0455cc36&"
import script from "./OrdersDraft.vue?vue&type=script&lang=js&"
export * from "./OrdersDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports